const types = {
	FETCH_BIDS_START: 'FETCH_BIDS_START',
	FETCH_BIDS_ERROR: 'FETCH_BIDS_ERROR',
	FETCH_BIDS_SUCCESS: 'FETCH_BIDS_SUCCESS',
	DELETE_BID_START: 'DELETE_BID_START',
	DELETE_BID_ERROR: 'DELETE_BID_ERROR',
	DELETE_BID_SUCCESS: 'DELETE_BID_SUCCESS'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/bid-list/mutation-types.js